import script from "./DefaultProcess.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultProcess.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultProcess.vue?vue&type=style&index=0&id=2f7814bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7814bd"]])

export default __exports__